import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import somethingWrongImage from './something-wrong.svg';
import bookingNotFoundImage from './booking-not-found.svg';
import orderCancelledImage from './order-cancelled.svg';
import noInternetImage from './no-internet-connection.svg';
import noDriverFoundImage from './no-driver-found.svg';
import serverErrorImage from './server-error.svg';
import orderCancelledGoSendImage from './order-cancelled-gosend.svg'
import allDriversBusy from './drivers-busy.svg'
import gojekLogo from './gojek-logo.svg';
import './style.scss';

// #HACK This code prefetches error images.
(() => {
  const preloadedImages = [noInternetImage, gojekLogo, serverErrorImage];
  window._PRELOADED_IMGS = preloadedImages.map(src => {
    const img = new Image();
    img.src = src;
    return img
  });
})();

export const ERROR_CODES = {
  BOOKING_NOT_FOUND: 1,
  DEFAULT_ERROR: 2,
  INVALID_LINK: 3,
  BOOKING_CANCELLED: 4,
  NO_INTERNET: 5,
  DRIVER_NOT_FOUND: 6,
  GO_SEND_BOOKING_CANCELLED: 7,
  GO_SEND_PARTNER_DRIVER_NOT_FOUND: 8,
  GO_SEND_PARTNER_BOOKING_CANCELLED: 10,
  GO_SEND_PARTNER_DISPATCH_CANCELLED: 11,
}

const viewForErrorCode = (code) => {
  const errorCodeToViewMap = {
    [ERROR_CODES.BOOKING_NOT_FOUND] : {
      titleId: "Error.bookingNotFound.title",
      messageId: "Error.bookingNotFound.message",
      image: bookingNotFoundImage,
    },
    [ERROR_CODES.DEFAULT_ERROR]: {
      titleId: "Error.default.title",
      messageId: "Error.default.message",
      image: serverErrorImage,
    },
    [ERROR_CODES.INVALID_LINK]: {
      titleId: "Error.invalidLink.title",
      messageId: "Error.invalidLink.message",
      image: somethingWrongImage,
    },
    [ERROR_CODES.BOOKING_CANCELLED]: {
      titleId: "Error.bookingCancelled.title",
      messageId: "Error.bookingCancelled.message",
      image: orderCancelledImage,
    },
    [ERROR_CODES.NO_INTERNET]: {
      titleId: "Error.noInternet.title",
      messageId: "Error.noInternet.message",
      image: noInternetImage,
    },
    [ERROR_CODES.DRIVER_NOT_FOUND]: {
      titleId: "Error.driverNotFound.title",
      messageId: "Error.driverNotFound.message",
      image: noDriverFoundImage,
    },
    [ERROR_CODES.GO_SEND_BOOKING_CANCELLED]: {
      titleId: "GoSend.Error.bookingCancelled.title",
      messageId: "GoSend.Error.bookingCancelled.message",
      image: orderCancelledImage,
    },
    [ERROR_CODES.GO_SEND_PARTNER_BOOKING_CANCELLED]: {
      titleId: "GoSendPartner.Error.bookingCancelled.title",
      messageId: "GoSendPartner.Error.bookingCancelled.message",
      image: orderCancelledGoSendImage,
    },
    [ERROR_CODES.GO_SEND_PARTNER_DRIVER_NOT_FOUND]: {
      titleId: "GoSendPartner.Error.driverNotFound.title",
      messageId: "GoSendPartner.Error.driverNotFound.message",
      image: allDriversBusy,
    },
    [ERROR_CODES.GO_SEND_PARTNER_DISPATCH_CANCELLED]: {
      titleId: "GoSendPartner.Error.bookingCancelled.title",
      messageId: "GoSendPartner.Error.dispatchBookingCancelled.message",
      image: orderCancelledGoSendImage,
    },
  };
  return errorCodeToViewMap[code];
}

const Error = ({code}) => {
  const {titleId, messageId, image} = viewForErrorCode(code);
  return (
    <div className="Error">
      <img className="gojekLogo" src={gojekLogo} alt="Gojek"/>
      <img className="errorImage" src={image} alt="Error"/>
      <p className="title">
        <FormattedMessage
          id={titleId}
        />
      </p>
      <p className="message">
        <FormattedMessage
          id={messageId}
        />
      </p>
    </div>
  )
};

Error.propTypes = {
  code: PropTypes.oneOf(Object.values(ERROR_CODES))
}

export default Error;
